const Domain = () => {
  return <h1>Domain</h1>;
};
export default Domain;
